import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpParams} from "@angular/common/http";
import { environment } from "src/environment";
import {  paymentInformation, SetPaymentReminder, CancellationReasons, SetCancellationReasons, 
    CancellationReasonsRedirect,SetSpecialOffer,RelevantContents,CancelledPageContents, paywallHomeURL, cancelSubscription, freePlanCancelSubscription} from "src/app/shared/constants";
import { map,catchError } from "rxjs/operators";
import { UikitService } from "./uikit.service";
import { StorageService } from "./storage.service";
import { SettingsService } from "./settings.service";
import { BaseService } from "./base.service";
import { DatalayerService } from "./datalayer.service";
import { Router } from "@angular/router";
import { InhouseAnalyticsService } from "./inhouse-analytics.service";

@Injectable({
    providedIn: 'root'
})

export class churnService{

    params;
    paymentType;
    constructor(private http:HttpClient, private storageService:StorageService, private uikitService: UikitService, private settingsService: SettingsService,
        private baseService: BaseService, private datalayerService: DatalayerService, private router: Router, private analyticsService: InhouseAnalyticsService){}

    getUserInfo(): Observable<any> {
        const body = {};
        Object.assign(body,this.settingsService.handleDataMartAnalyticsParamsData())
        const userUrl = environment.apiEndpoint + environment.version + paymentInformation ;
        return this.http.post(userUrl, body).pipe(
            map((response:any)=>{
                if(response.status_code === 200){
                    this.paymentType = response.data.payment_type;
                    return response;
                }
                else{
                    this.uikitService.notifyError(response);
                }
            }), catchError((error) => {
                if (error?.error?.error?.code !== 1002) {
                  this.uikitService.notifyError(error);
                }
                return error;
            })
        );
    }

    setPaymentReminder(): Observable<any> {
        const body = {};
        Object.assign(body,this.settingsService.handleDataMartAnalyticsParamsData())
        const paymentReminderUrl = environment.apiEndpoint + environment.version + SetPaymentReminder;
        return this.http.post(paymentReminderUrl,body).pipe(
            map((response:any)=>{
                if(response.status_code === 200){
                    return response;
                }else{
                    this.uikitService.notifyError(response);
                }
            }), catchError((error) => {
                if(error?.error?.error?.code !== 1002){
                    this.uikitService.notifyError(error);
                }
                return error;
            })
        )
    }

    cancellationReasons():Observable<any>{
        const body = {};
        Object.assign(body,this.settingsService.handleDataMartAnalyticsParamsData())
        const cancellationReasonsUrl = environment.apiEndpoint + environment.version + CancellationReasons;
        return this.http.post(cancellationReasonsUrl,body).pipe(
            map((response:any)=>{
                if(response.status_code === 200){
                    return response;
                }else{
                    this.uikitService.notifyError(response);
                }
            }), catchError((error)=>{
                if(error?.error?.error?.code !== 1002){
                    this.uikitService.notifyError(error);
                }
                return error;
            })
        )
    }

    setCancellationReasons(data:any):Observable<any>{
        const body = {
            reasons:data.reason,
            opted_promotional_mails:data.opted_promotional_mail,
            message:data.messages
         }
         Object.assign(body,this.settingsService.handleDataMartAnalyticsParamsData())
         const setCancellationReasonsUrl = environment.apiEndpoint + environment.version + SetCancellationReasons;
         return this.http.post(setCancellationReasonsUrl,body).pipe(
             map((response:any)=>{
                 if(response.status_code === 200){
                     return response;
                 }else{
                     this.uikitService.notifyError(response);
                 }
             }), catchError((error)=>{
                 if(error?.error?.error?.code !== 1002){
                     this.uikitService.notifyError(error);
                 }
                 return error;
             })
         )
    }

    cancellationRedirect(datas:any):Observable<any>{
        const body ={
            reason:datas.reason,
            message:datas.messages
        }
        Object.assign(body,this.settingsService.handleDataMartAnalyticsParamsData())
        const cancellationRedirectUrl = environment.apiEndpoint + environment.version + CancellationReasonsRedirect;
        return this.http.post(cancellationRedirectUrl,body).pipe(
            map((response:any)=>{
                if(response.status_code === 200){
                    return response;
                }else{
                    this.uikitService.notifyError(response);
                }
            }), catchError((error)=>{
                if(error?.error?.error?.code !== 1002){
                    this.uikitService.notifyError(error);
                }
                return error;
            })
        )
    }
    
    setSpecialOffer():Observable<any>{
        const body = {};
        Object.assign(body,this.settingsService.handleDataMartAnalyticsParamsData())
        const setSpecialOfferUrl = environment.apiEndpoint + environment.version + SetSpecialOffer;
        return this.http.post(setSpecialOfferUrl,body).pipe(
            map((response:any)=>{
                if(response.status_code === 200){
                    return response;
                }else{
                    this.uikitService.notifyError(response);
                }
            }), catchError((error)=>{
                if(error?.error?.error?.code !== 1002){
                    this.uikitService.notifyError(error);
                }
                return error;
            })
        )
    }

    releventContent():Observable<any>{
        this.params = new HttpParams()
        .set('version','v1');
        Object.assign(this.params,this.settingsService.handleDataMartAnalyticsParamsData())
        const releventContentUrl = environment.apiEndpoint + environment.version + RelevantContents;
        return this.http.get<any>(releventContentUrl, {params:this.params}).pipe(
            map((response:any)=>{
                if(response.status_code === 200){
                    return response;
                }else{
                    this.uikitService.notifyError(response);
                }
            }), catchError((error)=>{
                if(error?.error?.error?.code !== 1002){
                    this.uikitService.notifyError(error);
                }
                return error;
            })
        )
    }

    getFaq(): Observable<any> {
        const region = this.storageService.getLocalStore('region');
        const locale = this.storageService.getLocalStore('locale');
        const countryCode = this.storageService.getLocalStore('country_code');
        this.params = new HttpParams()
        .set('region', region)
        .set('locale', locale)
        .set('country_code', countryCode)
        Object.assign(this.params,this.settingsService.handleDataMartAnalyticsParamsData())
        const faqUrl = environment.apiEndpoint + environment.version + paywallHomeURL;
        return this.http.get<any>(faqUrl,{params:this.params}).pipe(
            map((response:any)=>{
                if(response.status_code === 200){
                    return response.data.home
                }else{
                    this.uikitService.notifyError(response);
                }
            }), catchError((error)=>{
                if(error?.error?.error?.code !== 1002){
                    this.uikitService.notifyError(error);
                }
                return error;
            })
        )
    }

    cancelledPageContent():Observable<any>{
        this.params = new HttpParams()
        .set('version','v1');
        Object.assign(this.params,this.settingsService.handleDataMartAnalyticsParamsData())
        const cancelledContentUrl = environment.apiEndpoint + environment.version + CancelledPageContents;
        return this.http.get<any>(cancelledContentUrl,{params:this.params}).pipe(
            map((response:any)=>{
                if(response.status_code === 200){
                    return response;
                }else{
                    this.uikitService.notifyError(response);
                }
            }), catchError((error)=>{
                if(error?.error?.error?.code !== 1002){
                    this.uikitService.notifyError(error);
                }
                return error;
            })
        )
    }
    // normal plan cancellation
    cancellingSubscription(data:any):Observable<any>{
        const body = {
            subscription_id:data.subscription_id
        }
        Object.assign(body,this.settingsService.handleDataMartAnalyticsParamsData())
        const cancellingSubscription = environment.apiEndpoint + environment.version + cancelSubscription;
        return this.http.post(cancellingSubscription,body).pipe(
            map((response:any)=>{
                const eventObj = {
                    event_type: 'Event',
                    event_name: 'Cancel Subscription',
                    event_status: 'Success',
                };
                this.analyticsService.trackUserActions(eventObj);
                if(response.status_code === 200){
                    this.storageService.removeLocalStore('subsId');
                    return response;
                }else{
                    this.uikitService.notifyError(response);
                }
            }), catchError((error)=>{
                if(error?.error?.error?.code !== 1002){
                    this.uikitService.notifyError(error);
                }
                const eventObj = {
                    event_type: 'Event',
                    event_name: 'Cancel Subscription',
                    event_status: 'Failure',
                    event_description: error
                };
                this.analyticsService.trackUserActions(eventObj);
                return error;
            })
        )
    }
    // Free plan cancellation
    cancellingFreeSubscription(data:any):Observable<any>{
        const body = {
            subscription_id: data.subscription_id
        }
        Object.assign(body, this.settingsService.handleDataMartAnalyticsParamsData())
        const freePlanCancelSubscriptionUrl = environment.apiEndpoint + environment.version + freePlanCancelSubscription;
        return this.http.post(freePlanCancelSubscriptionUrl, body).pipe(
            map((response:any)=>{
                const eventObj = {
                    event_type: 'Event',
                    event_name: 'Cancel Subscription - free plan',
                    event_status: 'Success',
                };
                this.analyticsService.trackUserActions(eventObj);
                if(response.status_code === 200) {
                    this.storageService.removeLocalStore('subsId');
                    return response;
                } else{
                    this.uikitService.notifyError(response);
                    const eventObj = {
                        event_type: 'Event',
                        event_name: 'Cancel Subscription - free plan',
                        event_status: 'Failure',
                        event_description: response
                    };
                    this.analyticsService.trackUserActions(eventObj);
                }
            }), catchError((error)=>{
                if(error.error && error.error.code !== 1002) {
                    this.uikitService.notifyError(error);
                }
                const eventObj = {
                    event_type: 'Event',
                    event_name: 'Cancel Subscription - free plan',
                    event_status: 'Failure',
                    event_description: error.error.message
                };
                this.analyticsService.trackUserActions(eventObj);
                return error;
            })
        )
    }

    cancelUserSubscription(data, subscribedPlan) {
        if (this.paymentType == 'free-plan') {
            this.cancellingFreeSubscription(data).subscribe(res => {
              if( res.status_code === 200) {
                this.cancelSubscriptionGAEvent(subscribedPlan);
                this.router.navigateByUrl('/churn/cancel');
              }
            });
        } else {
            this.cancellingSubscription(data).subscribe(res => {
                if( res.status_code === 200) {
                this.cancelSubscriptionGAEvent(subscribedPlan);
                this.router.navigateByUrl('/churn/cancel');
                }
            });
        }
    }

    cancelSubscriptionGAEvent(subscribedPlan) {
        const datalayerData = {
          event: 'GAEvent',
          eventCategory: 'Payment',
          eventAction: 'Cancel',
          eventLabel: subscribedPlan?.title,
          eventValue: subscribedPlan?.amount,
          loginStatus: (this.storageService.getLocalStore('u_id') ? 'True' : 'False'),
          userId: (this.storageService.getLocalStore('u_id') ? this.storageService.getLocalStore('u_id') : ''),
          notificationStatus: localStorage.getItem('emailNotify') ||  'False',
          region: (this.storageService.getLocalStore('region') ? this.storageService.getLocalStore('region') : ''),
          platform: this.baseService.browserType,
          userStatus: this.storageService.getLocalStore('user_type')
        };
        this.datalayerService.addDatalayer(datalayerData);
      }

}